import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

export function useLargeTablet() {
  const theme = useTheme();
  const isLargeTablet = useMediaQuery(theme.breakpoints.down("lg"));
  return isLargeTablet;
}
